import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

export const { Types, Creators } = createActions({
  anomalyManagementRequest: [],
  getAnomalies: ['query'],
  postAnomalies: ['request'],
  anomalyManagementSuccess: ['data'],
  anomalyManagementError: ['err'],
});

/* Initial State */

export const INITIAL_STATE = Immutable({
  data: [],
  success: false,
  loading: false,
  error: false,
});

/* Reducers */

export const request = state => state.merge({ success: false, loading: true });

export const success = (state, { data }) => state.merge({ data, error: false, loading: false, success: true });

export const error = state => state.merge({ loading: false, error: true, success: false });

/* Reducers to types */

export default createReducer(INITIAL_STATE, {
  [Types.ANOMALY_MANAGEMENT_REQUEST]: request,
  [Types.ANOMALY_MANAGEMENT_SUCCESS]: success,
  [Types.ANOMALY_MANAGEMENT_ERROR]: error,
});
